import SoundNotificationManager from './SoundNotificationManager';
import connectContainer from './SoundNotificationManagerContainer';

export default connectContainer(SoundNotificationManager);
